import { fetchTeamoTokeIdApi } from 'api/profile/fetchProfileTeamo'

export const FETCH_TEAMO_TOKEN = 'FETCH_TEAMO_TOKEN' as const

export const fetchTeamoTokenAction = () => ({
  type: FETCH_TEAMO_TOKEN,
  promise: () => fetchTeamoTokeIdApi(),
})
